import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import ModalComponent from "../../../CoreComponents/ModalComponent";
import { ManageItemVariant } from "../Logics";
import { showMessage } from "../../../Functionalities/Functions";
import { validateVariant } from "../variantValidation";
import { priceWithCommission } from "../variantPrice";
import VariantFields from "./VariantFields";

const newVariantDefaults = {
  id: "",
  varient_id: "",
  varient_name: "",
  magnitude: 0.0,
  rate: "",
  offer_rate: "",
  mrp: 0.0,
  offer_enabled: false,
  name: "",
  dual_name: "",
  description: "",
  dual_description: "",
  type: "",
  food_type: "",
  order_limit: "",
  commission_rate: 0,
};

function ProductVariantsSection({ data, getData }) {
  const { id } = useParams();

  const [variantsData, setVariantsData] = useState({
    ...newVariantDefaults,
    item_id: id,
  });

  const clearVariantData = () => {
    setVariantsData({ ...newVariantDefaults, item_id: id });
  };

  const variantValidation = () => {
    const error = validateVariant(variantsData);
    if (error) {
      showMessage(error, "danger", "Validation failed", "top", "top-right", 0);
      return 0;
    }
    return 1;
  };

  const addVariant = (e) => {
    e.preventDefault();
    if (!variantValidation()) return;
    ManageItemVariant("", "add", variantsData, "")
      .then((res) => {
        if (res.data.Status === true) {
          showMessage("Variant added", "success", "Success!", "top", "top-right", 0);
          clearVariantData();
          getData();
        } else {
          showMessage(res.data.Error, "danger", "Error!", "top", "top-right", 0);
        }
      })
      .catch(() => showMessage("Could not save the variant", "danger", "Error!", "top", "top-right", 0));
  };

  return (
    <div>
      {/* Edit Variant/Portion Modal */}
      <ModalComponent
        heading={"Edit Variant/Portion"}
        primaryButton={(e) => {
          e.preventDefault();
          clearVariantData();
        }}
        primaryButtonName={"Cancel"}
        secondaryButton={(e) => {
          e.preventDefault();
          let res = variantValidation();
          if (!res) {
            return 0;
          }

          let result = ManageItemVariant("", "update", variantsData, "");
          result
            .then((res) => {
              if (res.data.Status === true) {
                showMessage(
                  "variant updated",
                  "success",
                  "Success!",
                  "top",
                  "top-right",
                );
                clearVariantData();
                getData();
              } else {
                showMessage(
                  res.data.Error,
                  "danger",
                  "Error!",
                  "top",
                  "top-right",
                );
              }
            })
            .catch((err) => err);
        }}
        secondaryButtonName={"Submit"}
        centerBottonButton={true}
      >
        <VariantFields value={variantsData} onChange={setVariantsData} />
      </ModalComponent>

      <p>
        <a data-toggle="modal" data-target="#sendMessageModal" href="" onClick={clearVariantData}>
          <span className="item badge badge-circle badge-success">
            <i className="ti-plus"></i>
          </span>
        </a>{" "}
        Add Variant/Portion
      </p>

      {/* Add Variant/Portion Modal */}
      <div className="modal fade" id="sendMessageModal">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Variant/Portion</h5>
              <button type="button" className="close" data-dismiss="modal">
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <form className="comment-form">
                <div className="row">
                  <VariantFields value={variantsData} onChange={setVariantsData} />

                  <div className="col-lg-12">
                    <div className="form-group mb-0 text-center">
                      <button
                        style={{ marginRight: 10 }}
                        data-dismiss="modal"
                        type="submit"
                        className="submit btn btn-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          clearVariantData();
                        }}
                      >
                        Cancel
                      </button>

                      <button
                        style={{ marginRight: 10 }}
                        data-dismiss="modal"
                        type="submit"
                        className="submit btn btn-primary"
                        onClick={addVariant}
                      >
                        Submit and close
                      </button>

                      <input
                        type="submit"
                        className="submit btn btn-primary"
                        onClick={addVariant}
                        name="submit"
                        value="Submit"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {data.varients.map((pdt, index) => {
        return (
          <div key={pdt.id || index}>
            <p>
              <i>
                <a
                  onClick={() => {
                    confirmAlert({
                      customUI: ({ onClose }) => {
                        return (
                          <div
                            className="custom-ui"
                            style={{
                              borderRadius: 8,
                              border: "solid",
                              padding: 70,
                              borderWidth: 0.5,
                            }}
                          >
                            <h1>Are you sure?</h1>
                            <p>You want to delete ?</p>
                            <button
                              onClick={onClose}
                              className="btn btn-primary"
                              style={{ marginRight: 10 }}
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => {
                                ManageItemVariant(
                                  "",
                                  "delete",
                                  "",
                                  "id=" + pdt.id,
                                )
                                  .then((res) => {
                                    if (res.data.Status === true) {
                                      showMessage(
                                        "Delete success",
                                        "success",
                                        "Success!",
                                        "top",
                                        "top-right",
                                        0,
                                      );
                                      getData();
                                      onClose();
                                    } else {
                                      showMessage(
                                        res.data.Error,
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0,
                                      );
                                    }
                                  })
                                  .catch((err) => {
                                    showMessage(
                                      "Delete Failed",
                                      "danger",
                                      "Error!",
                                      "top",
                                      "top-right",
                                      0,
                                    );
                                  });
                              }}
                              className="btn btn-primary"
                            >
                              Delete
                            </button>
                          </div>
                        );
                      },
                    });
                  }}
                >
                  <span className="item badge badge-circle badge-danger">
                    <i className="fa fa-trash"></i>
                  </span>
                </a>
                <a
                  data-toggle="modal"
                  data-target="#sendModal"
                  onClick={() =>
                    setVariantsData({
                      ...pdt,
                      item_id: id,
                      food_type: pdt.type || pdt.food_type || "",
                    })
                  }
                >
                  <span
                    className="item badge badge-circle badge-secondary mr-2"
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa fa-edit"></i>
                  </span>
                </a>
              </i>
              {pdt.name}
              <b style={{ color: "black", fontSize: "16px" }}>{" | "}</b>
              Rs :{" "}
              {pdt.offer_enabled ? (
                <b>{priceWithCommission(pdt.offer_rate, pdt.commission_rate)}</b>
              ) : (
                priceWithCommission(pdt.rate, pdt.commission_rate)
              )}{" "}
              {` (rate : ${priceWithCommission(
                pdt.rate,
                pdt.commission_rate,
              )}, offer rate : ${priceWithCommission(
                pdt.offer_rate,
                pdt.commission_rate,
              )})`}
              <b style={{ color: "black", fontSize: "16px" }}>{" | "}</b>
              Max order limit : {pdt.order_limit} {pdt.description}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default ProductVariantsSection;
